
import api from "@/services/api"
import { CasesNotification } from "@/types/notification"

class ApiNotification {
    public axios: any;

    public async notificationList (): Promise<CasesNotification[]> { return (await this.axios.get("/notifications")).data }
    public async notificationDelete (casesNotification: CasesNotification): Promise<void> { await this.axios.delete(`/notifications/${casesNotification.id}`) }
}

const apiNotification = new ApiNotification()
export default apiNotification
